import React from 'react';
import { styled, darken } from '@material-ui/core';
import MuiButton, { ButtonProps as MuiButtonProps } from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

export interface ButtonProps extends MuiButtonProps {
  loading?: boolean;
  rounded?: boolean;
}

const BaseButton = styled(MuiButton)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: 'none',
  minWidth: 235,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '&:disabled': {
    backgroundColor: theme.palette.grey[500],
    color: theme.palette.grey[100],
  },
  '&:hover': {
    boxShadow: 'none',
    cursor: 'pointer',
    backgroundColor: darken(theme.palette.primary.main, 0.1),
  },
  '&:active, &:focus': {
    boxShadow: 'none',
  },
  padding: '10px 24px',
}));

const SelectButton = styled(BaseButton)(({ theme }) => ({
  backgroundColor: theme.palette.grey[300],
  color: theme.palette.text.primary,
  borderRadius: 8,
  padding: '8px 12px',
  '&:hover': {
    backgroundColor: darken(theme.palette.grey[300], 0.05),
  },
  '&:active, &:focus': {
    border: '1px solid',
    backgroundColor: darken(theme.palette.grey[300], 0.05),
  },
}));

const Button = ({
  children,
  disabled,
  rounded = false,
  loading = false,
  ...props
}: ButtonProps) => (
  <BaseButton
    disabled={disabled || loading}
    {...(rounded && { style: { borderRadius: 56 } })}
    {...props}
  >
    {loading
      ? <CircularProgress size={24} color="inherit" />
      : children}
  </BaseButton>
);

export default Button;

export { SelectButton };
